
import React from 'react';

export const StatsSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-gray-900">Neden Özgür OSGB?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Sahada aktif, çözüm odaklı ve şeffaf bir çalışma modeli benimser. Sadece yasal zorunlulukları yerine getirmekle kalmaz; işveren ve çalışanların güvenlik farkındalığını artırmayı amaçlarız.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-line text-3xl text-green-600"></i>
            </div>
            <div className="text-4xl font-bold text-green-600 mb-2">10+</div>
            <div className="text-lg text-gray-700">Yıllık Sektör Deneyimi</div>
          </div>
          
          <div className="text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-building-line text-3xl text-green-600"></i>
            </div>
            <div className="text-4xl font-bold text-green-600 mb-2">120+</div>
            <div className="text-lg text-gray-700">İşletmeye Aktif Hizmet</div>
          </div>
          
          <div className="text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-group-line text-3xl text-green-600"></i>
            </div>
            <div className="text-4xl font-bold text-green-600 mb-2">5000+</div>
            <div className="text-lg text-gray-700">Çalışan Eğitimi</div>
          </div>
          
          <div className="text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-green-600"></i>
            </div>
            <div className="text-4xl font-bold text-green-600 mb-2">%100</div>
            <div className="text-lg text-gray-700">Yönetmelik Uyumluluğu</div>
          </div>
        </div>
        
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gray-50 rounded-xl p-8 border border-gray-200">
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Değer Yaklaşımımız</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-check-line text-green-600 mt-1 mr-3"></i>
                <span className="text-gray-700">Sürekli takip ve raporlama sistemi</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-green-600 mt-1 mr-3"></i>
                <span className="text-gray-700">Şeffaf iletişim ve sürdürülebilir güvenlik kültürü</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-green-600 mt-1 mr-3"></i>
                <span className="text-gray-700">Her işletmeye özel hizmet planı</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-green-600 mt-1 mr-3"></i>
                <span className="text-gray-700">Tüm süreçleri belgelendirir ve denetime hazır sistem</span>
              </li>
            </ul>
          </div>
          
          <div className="bg-gray-50 rounded-xl p-8 border border-gray-200">
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Çalışma Sürecimiz</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center mr-4 mt-1">
                  <span className="text-sm font-bold text-white">1</span>
                </div>
                <span className="text-gray-700">İşletme tanıma ve saha incelemesi</span>
              </div>
              <div className="flex items-start">
                <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center mr-4 mt-1">
                  <span className="text-sm font-bold text-white">2</span>
                </div>
                <span className="text-gray-700">Risklerin ve ihtiyaçların belirlenmesi</span>
              </div>
              <div className="flex items-start">
                <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center mr-4 mt-1">
                  <span className="text-sm font-bold text-white">3</span>
                </div>
                <span className="text-gray-700">Yıllık İSG planlaması ve hizmet takvimi</span>
              </div>
              <div className="flex items-start">
                <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center mr-4 mt-1">
                  <span className="text-sm font-bold text-white">4</span>
                </div>
                <span className="text-gray-700">Düzenli saha denetimleri, eğitimler ve ölçümler</span>
              </div>
              <div className="flex items-start">
                <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center mr-4 mt-1">
                  <span className="text-sm font-bold text-white">5</span>
                </div>
                <span className="text-gray-700">Aksiyon yönetimi ve sürekli iyileştirme</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
